module.exports = __webpack_public_path__ + "media/images/social_svgs/x-747195e1780820e2444ede4257615cc3.svg";